import { useRef, useState, useCallback } from 'react';

// Reemplazo drop-in de `react-slide-toggle` (sin dependencias, animación CSS).
// Mantiene la misma API de render-prop: children recibe
// { onToggle, setCollapsibleElement, toggleState } donde toggleState es
// 'EXPANDED' | 'COLLAPSED' | 'EXPANDING' | 'COLLAPSING'.
export default function SlideToggle({ collapsed = true, duration = 300, children }) {
  const elRef = useRef(null);
  const [toggleState, setToggleState] = useState(collapsed ? 'COLLAPSED' : 'EXPANDED');

  const setCollapsibleElement = useCallback(
    (el) => {
      elRef.current = el;
      if (el && collapsed) {
        el.style.height = '0px';
        el.style.overflow = 'hidden';
      }
    },
    [collapsed],
  );

  const expand = (el) => {
    el.style.overflow = 'hidden';
    el.style.transition = `height ${duration}ms ease`;
    el.style.height = el.scrollHeight + 'px';
    setToggleState('EXPANDING');
    const onEnd = () => {
      el.style.height = 'auto';
      el.style.overflow = '';
      el.style.transition = '';
      setToggleState('EXPANDED');
      el.removeEventListener('transitionend', onEnd);
    };
    el.addEventListener('transitionend', onEnd);
  };

  const collapse = (el) => {
    el.style.overflow = 'hidden';
    el.style.height = el.scrollHeight + 'px';
    // forzar reflow para que la transición arranque desde la altura actual
    void el.offsetHeight;
    el.style.transition = `height ${duration}ms ease`;
    el.style.height = '0px';
    setToggleState('COLLAPSING');
    const onEnd = () => {
      el.style.transition = '';
      setToggleState('COLLAPSED');
      el.removeEventListener('transitionend', onEnd);
    };
    el.addEventListener('transitionend', onEnd);
  };

  const onToggle = () => {
    const el = elRef.current;
    if (!el) return;
    if (toggleState === 'EXPANDED' || toggleState === 'EXPANDING') {
      collapse(el);
    } else {
      expand(el);
    }
  };

  return children({ onToggle, setCollapsibleElement, toggleState });
}
